/**
 * Date expressed according to ISO 8601
 *
 * https://en.wikipedia.org/wiki/ISO_8601
 */
export const getApiDateFormat = (): string => {
  return 'YYYY-MM-DD';
};
